import { render, staticRenderFns } from "./InvoiceSettingEdit.vue?vue&type=template&id=1f961906&"
import script from "./InvoiceSettingEdit.vue?vue&type=script&lang=js&"
export * from "./InvoiceSettingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports